import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../api/client";
import { customDateFormatType2 } from "../utils/utils";

const queryKey = "chart";

async function fetchChart(employeeId, startTime, endTime) {
  try {
    const options = {};

    if (employeeId) options.employeeId = employeeId;
    if (startTime) options.startTime = customDateFormatType2(startTime);
    if (endTime) options.endTime = customDateFormatType2(endTime);

    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI("get", `/commissionAnalyst/chart?${queryParams}`);
    
    const newDataPeriod = data?.items.map((item, index) => {
      return item?.count || 0;
    });

    const newDataSales = data?.items.map((item, index) => {
      return item?.price ? (item?.price / 1000000000).toFixed(2) : 0;
    });

    return { dataPeriod: newDataPeriod, dataSales: newDataSales };
  } catch (error) {
    console.error("Error fetching checkIn data:", error);
    return { data: [], totalPages: 0 };
  }
}

export function useChart(employeeId, startTime, endTime) {
  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [queryKey, employeeId, startTime, endTime],
    queryFn: () => fetchChart(employeeId, startTime, endTime),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error("Error fetching checkIn data:", error);
    },
  });

  return {
    periodData: data?.dataPeriod,
    dataSales: data?.dataSales,
    refetch,
    isLoading,
    isRefetching,
    entries: data?.entries,
    startEntry: data?.startEntry,
    endEntry: data?.endEntry,
  };
}
